import React from "react";
import { SelectField, Input, Text } from "@aws-amplify/ui-react";
import { QuarterSpliltScreen } from "./QuarterSplitScreenLayout";
import { I18n } from "aws-amplify";

function FieldSearch({ filter, setFilter, showText }) {
  const [displayValue, setDisplayValue] = React.useState("");
  const handleFieldChange = (event) => {
    const selectedValue = event.target.value;
    let newFilter = { ...filter };

    if (selectedValue === "eBoxDocumentDate") {
      newFilter = {
        ...newFilter,
        field: selectedValue,
        option: [
          I18n.get("Equals"),
          I18n.get("Earlier than"),
          I18n.get("Later than"),
        ],
        showDateInput: true,
        selectedOption: I18n.get("Equals"),
        inputValue: "",
      };
    } else if (selectedValue === "eBoxContiInvoiceAmount") {
      newFilter = {
        ...newFilter,
        field: selectedValue,
        option: [
          I18n.get("Equals"),
          I18n.get("Does not equal"),
          I18n.get("Greater than"),
          I18n.get("Less than"),
        ],
        showDateInput: false,
        selectedOption: I18n.get("Equals"),
        inputValue: "",
      };
    } else {
      newFilter = {
        ...newFilter,
        field: selectedValue,
        option: [
          I18n.get("Contains"),
          I18n.get("Does not contain"),
          I18n.get("Equals"),
          I18n.get("Does not equal"),
          I18n.get("Begins with"),
        ],
        showDateInput: false,
        selectedOption: I18n.get("Contains"),
        inputValue: "",
      };
    }
    setFilter(newFilter);
  };

  const handleOptionChange = (event) => {
    setFilter({
      ...filter,
      selectedOption: event.target.value,
      inputValue: "",
    });
    setDisplayValue("");
  };

  const handleInputChange = (event) => {
    const originalValue = event.target.value;
    let transformedValue = originalValue;
    const lowerCasedValue = originalValue.toLowerCase();

    if (["neu", "new"].includes(lowerCasedValue)) {
      transformedValue = "1";
    } else if (["gelesen", "read"].includes(lowerCasedValue)) {
      transformedValue = "2";
    } else if (["heruntergeladen", "downloaded"].includes(lowerCasedValue)) {
      transformedValue = "3";
    }

    setFilter({
      ...filter,
      inputValue: transformedValue,
    });
    setDisplayValue(originalValue);
  };

  return (
    <QuarterSpliltScreen
      firstWeight={1}
      secondWeight={1}
      thirdWeight={1}
      fourthWeight={1}
    >
      {showText && (
        <Text className="search-content">
          {I18n.get("Where the property...")}{" "}
        </Text>
      )}
      <SelectField value={filter.field} onChange={handleFieldChange}>
        <option value="select">{I18n.get("(Pick Property)")}</option>
        <option value="eBoxContiCurrency">{I18n.get("Currency")}</option>
        <option value="eBoxContiDocIssuer">{I18n.get("Doc. Issuer")}</option>
        <option value="eBoxDocumentDate">{I18n.get("Document Date")}</option>
        <option value="eBoxDocumentNumber">{I18n.get("Document No.")}</option>
        <option value="eBoxViewStatus">{I18n.get("Document state")}</option>
        <option value="eBoxContiPartnerSender">
          {I18n.get("Partner Nr at Issuer")}
        </option>
        <option value="eBoxContiPartnerReceiver">
          {I18n.get("Partner Nr at Receiver")}
        </option>
        <option value="eBoxContiInvoiceAmount">
          {I18n.get("Total invoice amount")}
        </option>
        <option value="eBoxContiVatID">
          {I18n.get("VAT ID (Doc. Receiver)")}
        </option>
      </SelectField>
      <SelectField
        className="dependent-dropdown"
        value={filter.selectedOption}
        onChange={handleOptionChange}
      >
        {filter.option.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </SelectField>
      {filter.showDateInput ? (
        <Input
          type="date"
          value={filter.inputValue}
          onChange={handleInputChange}
        />
      ) : (
        <Input type="text" value={displayValue} onChange={handleInputChange} />
      )}
    </QuarterSpliltScreen>
  );
}

export default FieldSearch;
